const num = (v) => Number(v);

const ok = (...values) =>
    values.every(
        (v) =>
            v !== "" &&
            v !== null &&
            v !== undefined &&
            Number.isFinite(Number(v))
    );


export function calculateMedicalTool(slug, d) {

    switch (slug) {

        case "bmi": {
            if (!ok(d.weight, d.height) || num(d.height) <= 0) return null;
            const h = num(d.height) / 100;
            return {
                value: num(d.weight) / (h * h),
                decimals: 1,
                unit: "kg/m²"
            };
        }


        case "bsa-mosteller": {
            if (!ok(d.weight, d.height) || num(d.weight) <= 0 || num(d.height) <= 0) return null;
            return {
                value: Math.sqrt(
                    (num(d.height) * num(d.weight)) / 3600
                ),
                decimals: 2,
                unit: "m²"
            };
        }


        case "ibw-devine": {
            if (!ok(d.height) || !d.sex) return null;

            const inches = num(d.height) / 2.54;

            if (inches < 60) {
                return {
                    text: "Công thức Devine chuẩn thường được biểu diễn cho chiều cao từ 5 ft trở lên."
                };
            }

            const extra = inches - 60;

            return {
                value:
                    (d.sex === "female" ? 45.5 : 50) +
                    2.3 * extra,
                decimals: 1,
                unit: "kg"
            };
        }


        case "adjusted-body-weight": {
            if (!ok(d.actualWeight, d.idealWeight)) return null;
            return {
                value:
                    num(d.idealWeight) +
                    0.4 *
                    (
                        num(d.actualWeight) -
                        num(d.idealWeight)
                    ),
                decimals: 1,
                unit: "kg"
            };
        }


        case "map": {
            if (!ok(d.sbp, d.dbp)) return null;
            return {
                value:
                    (
                        num(d.sbp) +
                        2 * num(d.dbp)
                    ) / 3,
                decimals: 1,
                unit: "mmHg"
            };
        }


        case "pulse-pressure": {
            if (!ok(d.sbp, d.dbp)) return null;
            return {
                value:
                    num(d.sbp) -
                    num(d.dbp),
                decimals: 0,
                unit: "mmHg"
            };
        }


        case "shock-index": {
            if (!ok(d.heartRate, d.sbp) || num(d.sbp) <= 0) return null;
            return {
                value:
                    num(d.heartRate) /
                    num(d.sbp),
                decimals: 2,
                unit: ""
            };
        }


        case "egfr-ckd-epi-2021": {

            if (
                !ok(d.age, d.creatinine) ||
                !d.sex ||
                num(d.age) < 18 ||
                num(d.creatinine) <= 0
            ) {
                return null;
            }

            const female =
                d.sex === "female";

            const k =
                female ? 0.7 : 0.9;

            const alpha =
                female ? -0.241 : -0.302;

            const scr =
                num(d.creatinine);

            const ratio =
                scr / k;

            let value =
                142 *
                Math.pow(
                    Math.min(ratio, 1),
                    alpha
                ) *
                Math.pow(
                    Math.max(ratio, 1),
                    -1.2
                ) *
                Math.pow(
                    0.9938,
                    num(d.age)
                );

            if (female) {
                value *= 1.012;
            }

            return {
                value,
                decimals: 0,
                unit: "mL/phút/1,73 m²",
                detail:
                    "CKD-EPI 2021 creatinine"
            };
        }


        case "cockcroft-gault": {

            if (
                !ok(
                    d.age,
                    d.weight,
                    d.creatinine
                ) ||
                !d.sex ||
                num(d.creatinine) <= 0
            ) {
                return null;
            }

            let value =
                (
                    (140 - num(d.age)) *
                    num(d.weight)
                ) /
                (
                    72 *
                    num(d.creatinine)
                );

            if (d.sex === "female") {
                value *= 0.85;
            }

            return {
                value,
                decimals: 1,
                unit: "mL/phút",
                detail:
                    "Sử dụng cân nặng đã nhập"
            };
        }


        case "fena": {

            if (
                !ok(
                    d.urineNa,
                    d.serumNa,
                    d.urineCr,
                    d.serumCr
                ) ||
                num(d.serumNa) === 0 ||
                num(d.urineCr) === 0
            ) {
                return null;
            }

            return {
                value:
                    (
                        num(d.urineNa) *
                        num(d.serumCr)
                    ) /
                    (
                        num(d.serumNa) *
                        num(d.urineCr)
                    ) *
                    100,
                decimals: 2,
                unit: "%"
            };
        }


        case "feurea": {

            if (
                !ok(
                    d.urineUrea,
                    d.serumUrea,
                    d.urineCr,
                    d.serumCr
                ) ||
                num(d.serumUrea) === 0 ||
                num(d.urineCr) === 0
            ) {
                return null;
            }

            return {
                value:
                    (
                        num(d.urineUrea) *
                        num(d.serumCr)
                    ) /
                    (
                        num(d.serumUrea) *
                        num(d.urineCr)
                    ) *
                    100,
                decimals: 2,
                unit: "%"
            };
        }


        case "anion-gap": {

            if (
                !ok(
                    d.na,
                    d.cl,
                    d.hco3
                )
            ) {
                return null;
            }

            return {
                value:
                    num(d.na) -
                    (
                        num(d.cl) +
                        num(d.hco3)
                    ),
                decimals: 1,
                unit: "mmol/L"
            };
        }


        case "corrected-calcium": {

            if (
                !ok(
                    d.calcium,
                    d.albumin
                )
            ) {
                return null;
            }

            return {
                value:
                    num(d.calcium) +
                    0.8 *
                    (
                        4 -
                        num(d.albumin)
                    ),
                decimals: 2,
                unit: "mg/dL"
            };
        }


        case "serum-osmolality": {

            if (
                !ok(
                    d.na,
                    d.glucose,
                    d.bun
                )
            ) {
                return null;
            }

            return {
                value:
                    2 * num(d.na) +
                    num(d.glucose) / 18 +
                    num(d.bun) / 2.8,
                decimals: 1,
                unit: "mOsm/kg"
            };
        }


        case "osmolar-gap": {

            if (
                !ok(
                    d.measured,
                    d.na,
                    d.glucose,
                    d.bun
                )
            ) {
                return null;
            }

            const calculated =
                2 * num(d.na) +
                num(d.glucose) / 18 +
                num(d.bun) / 2.8;

            return {
                value:
                    num(d.measured) -
                    calculated,
                decimals: 1,
                unit: "mOsm/kg",
                detail:
                    `Osm tính toán: ${calculated.toFixed(1)} mOsm/kg`
            };
        }


        case "pf-ratio": {

            if (
                !ok(
                    d.pao2,
                    d.fio2
                ) ||
                num(d.fio2) <= 0
            ) {
                return null;
            }

            return {
                value:
                    num(d.pao2) /
                    (
                        num(d.fio2) /
                        100
                    ),
                decimals: 0,
                unit: ""
            };
        }


        case "rox-index": {

            if (
                !ok(
                    d.spo2,
                    d.fio2,
                    d.rr
                ) ||
                num(d.fio2) <= 0 ||
                num(d.rr) <= 0
            ) {
                return null;
            }

            return {
                value:
                    (
                        num(d.spo2) /
                        (
                            num(d.fio2) /
                            100
                        )
                    ) /
                    num(d.rr),
                decimals: 2,
                unit: ""
            };
        }


        case "qtc-bazett": {

            if (
                !ok(
                    d.qt,
                    d.heartRate
                ) ||
                num(d.heartRate) <= 0
            ) {
                return null;
            }

            const rrSeconds =
                60 /
                num(d.heartRate);

            return {
                value:
                    num(d.qt) /
                    Math.sqrt(rrSeconds),
                decimals: 0,
                unit: "ms"
            };
        }


        case "qtc-fridericia": {

            if (
                !ok(
                    d.qt,
                    d.heartRate
                ) ||
                num(d.heartRate) <= 0
            ) {
                return null;
            }

            const rrSeconds =
                60 /
                num(d.heartRate);

            return {
                value:
                    num(d.qt) /
                    Math.cbrt(rrSeconds),
                decimals: 0,
                unit: "ms"
            };
        }


        case "anc": {

            if (
                !ok(
                    d.wbc,
                    d.neutrophil
                )
            ) {
                return null;
            }

            const bands =
                d.bands === "" ||
                d.bands === undefined
                    ? 0
                    : num(d.bands);

            return {
                value:
                    num(d.wbc) *
                    (
                        num(d.neutrophil) +
                        bands
                    ) /
                    100,
                decimals: 0,
                unit: "/µL"
            };
        }


        case "nlr": {

            if (
                !ok(
                    d.neutrophil,
                    d.lymphocyte
                ) ||
                num(d.lymphocyte) === 0
            ) {
                return null;
            }

            return {
                value:
                    num(d.neutrophil) /
                    num(d.lymphocyte),
                decimals: 2,
                unit: ""
            };
        }


        case "fib4": {

            if (
                !ok(
                    d.age,
                    d.ast,
                    d.alt,
                    d.platelets
                ) ||
                num(d.alt) <= 0 ||
                num(d.platelets) <= 0
            ) {
                return null;
            }

            return {
                value:
                    (
                        num(d.age) *
                        num(d.ast)
                    ) /
                    (
                        num(d.platelets) *
                        Math.sqrt(
                            num(d.alt)
                        )
                    ),
                decimals: 2,
                unit: ""
            };
        }


        case "apri": {

            if (
                !ok(
                    d.ast,
                    d.astUln,
                    d.platelets
                ) ||
                num(d.astUln) <= 0 ||
                num(d.platelets) <= 0
            ) {
                return null;
            }

            return {
                value:
                    (
                        num(d.ast) /
                        num(d.astUln)
                    ) /
                    num(d.platelets) *
                    100,
                decimals: 2,
                unit: ""
            };
        }


        case "gcs": {

            if (
                !ok(
                    d.eye,
                    d.verbal,
                    d.motor
                )
            ) {
                return null;
            }

            const score =
                num(d.eye) +
                num(d.verbal) +
                num(d.motor);

            return {
                value: score,
                decimals: 0,
                unit: "/15",
                detail:
                    `E${d.eye} + V${d.verbal} + M${d.motor}`
            };
        }


        case "qsofa": {

            if (
                !ok(
                    d.rr,
                    d.sbp
                ) ||
                !d.alteredMentation
            ) {
                return null;
            }

            let score = 0;

            if (num(d.rr) >= 22) score++;
            if (num(d.sbp) <= 100) score++;
            if (d.alteredMentation === "yes") score++;

            return {
                value: score,
                decimals: 0,
                unit: "/3",
                detail:
                    "RR ≥22, SBP ≤100, thay đổi tri giác"
            };
        }


        case "curb65": {

            if (
                !ok(
                    d.age,
                    d.urea,
                    d.rr,
                    d.sbp,
                    d.dbp
                ) ||
                !d.confusion
            ) {
                return null;
            }

            let score = 0;

            if (d.confusion === "yes") score++;
            if (num(d.urea) > 7) score++;
            if (num(d.rr) >= 30) score++;

            if (
                num(d.sbp) < 90 ||
                num(d.dbp) <= 60
            ) {
                score++;
            }

            if (num(d.age) >= 65) {
                score++;
            }

            return {
                value: score,
                decimals: 0,
                unit: "/5"
            };
        }


        case "creatinine-converter": {

            if (!ok(d.value) || !d.direction) return null;

            if (d.direction === "mg-to-umol") {
                return {
                    value:
                        num(d.value) *
                        88.4,
                    decimals: 1,
                    unit: "µmol/L"
                };
            }

            return {
                value:
                    num(d.value) /
                    88.4,
                decimals: 2,
                unit: "mg/dL"
            };
        }


        case "glucose-converter": {

            if (!ok(d.value) || !d.direction) return null;

            if (d.direction === "mg-to-mmol") {
                return {
                    value:
                        num(d.value) /
                        18,
                    decimals: 2,
                    unit: "mmol/L"
                };
            }

            return {
                value:
                    num(d.value) *
                    18,
                decimals: 0,
                unit: "mg/dL"
            };
        }


        case "temperature-converter": {

            if (!ok(d.value) || !d.direction) return null;

            if (d.direction === "c-to-f") {
                return {
                    value:
                        num(d.value) *
                        9 / 5 +
                        32,
                    decimals: 1,
                    unit: "°F"
                };
            }

            return {
                value:
                    (
                        num(d.value) -
                        32
                    ) *
                    5 / 9,
                decimals: 1,
                unit: "°C"
            };
        }


        case "weight-converter": {

            if (!ok(d.value) || !d.direction) return null;

            if (d.direction === "kg-to-lb") {
                return {
                    value:
                        num(d.value) *
                        2.20462,
                    decimals: 2,
                    unit: "lb"
                };
            }

            return {
                value:
                    num(d.value) /
                    2.20462,
                decimals: 2,
                unit: "kg"
            };
        }


        default:
            return null;
    }
}
